import {
    InvoiceItemClassification,
    InvoiceItemDiscount,
    InvoiceItemInventory,
    InvoiceItemLabProfileRequest,
    InvoiceItemPrices,
    InvoiceItemService,
    InvoiceItemTax,
    InvoiceItemType,
    InvoiceItemParent,
    InvoiceItemChild,
} from './parts';
import { ProviderDetails } from '../';

export interface Status {
    type: string;
    message: string;
}

export interface Displayable {
    name: string;
    type: string;
}

export class InvoiceItem {
    barcode: string;

    childItems?: InvoiceItemChild[];

    classification: InvoiceItemClassification;

    clientDescription: string;

    discounts: InvoiceItemDiscount[];

    hospitalDescription: string;

    isActive = true;

    itemParent?: InvoiceItemParent;

    itemType: InvoiceItemType;

    labProfileRequest?: InvoiceItemLabProfileRequest;

    pimsGeneratedId: string;

    pimsId: string;

    masterSiteId?: string;

    prices: InvoiceItemPrices;

    provider: ProviderDetails;

    subClassification: InvoiceItemClassification | null;

    taxes: InvoiceItemTax[];

    typeDetails: InvoiceItemInventory | InvoiceItemService;

    practiceName?: string;

    supplierCode?: string;

    status?: Status;

    displayable?: Displayable;

    animanaSpecificFields?: {
        supplierCode?: string | null;

        packageFactor?: number;

        packageUnit?: string;

        orderFactor?: number;

        orderUnit?: string;

        vatCode?: string;

        supplierName?: string | null;

        productAnalysisGroup1Uuid?: string | null;

        productAnalysisGroup2Uuid?: string | null;

        productAnalysisGroup3Uuid?: string | null;

        productAnalysisGroup1Name?: string | null;

        productAnalysisGroup2Name?: string | null;

        productAnalysisGroup3Name?: string | null;

        warning?: string;

        humanDrug?: boolean;

        euthanasia?: boolean;

        memo?: string;

        informationSheetUrl?: string;

        updateDateTime?: Date;
    };
}
